import * as Sentry from "@sentry/react";
import { faMegaphone } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip } from "@mui/material";
import { ChosenThemeContext } from "@ngt/opms";
import { useContext, useEffect, useRef, useState } from "react";

const ToggleFeedbackButton = () => {
    const [feedback, _setFeedback] = useState(() => Sentry.getFeedback());
    const chosenTheme = useContext(ChosenThemeContext);
    const buttonRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if (buttonRef.current) {
            const unsubscribe = feedback?.attachTo(
                buttonRef.current, 
                { 
                    colorScheme: chosenTheme === 'dark' ? 
                        'dark' : 
                        chosenTheme === 'light' ? 
                            'light' : 
                            'system' 
                }
            );
            return () => {
                unsubscribe?.()
            }
        }
    }, [buttonRef, chosenTheme]);
    
    return (
        <Tooltip 
            title="Report a Bug"
        >
            <IconButton
                aria-label="theme"
                color="inherit"
                ref={buttonRef as any}
            >
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
}

export default ToggleFeedbackButton;